module.exports = __webpack_public_path__ + "static/media/709MeldrumStNW_2018-06-18_116.06aa975c.jpg";